import React, { useEffect, useState } from "react";
import IRouterComponentProps from "../../models/IRouterComponentProps";
import { Box, Typography, useTheme } from "@mui/material";
import { oAuth } from "../../routes/basic/BasicAppRouter";
import { useHistory, useLocation } from "react-router";
import { useMediaQuery } from "@material-ui/core";
import api, { publicApi } from "../../services/ApiService";
import {
  getLinkBranch,
  invitedUserBranchio,
} from "../../common/config/app.endpoints";
import AuthService from "../auth/AuthService";
import Styled from "styled-components";
import {
  AuctionState,
  getPastProducts,
  ProductState,
} from "../../services/ProductsApiService";
interface IProps extends IRouterComponentProps {
  t?: any;
}
const StyledIcon = Styled.img`
  width: 40px;
  height: 40px;
  cursor: pointer;
`;
function BranchRedirect(props: IProps) {
  let history = useHistory();
  const Auth = new AuthService();
  const [branchLink, setBranchLink] = useState<string | undefined>();
  const location = useLocation();
  const fullUrl = location.pathname + location.search;
  const query = new URLSearchParams(useLocation().search);
  const layout = useTheme();
  const isMobileRedirectVisible = useMediaQuery(
    layout.breakpoints.between("xs", "lg")
  );
  const [isZipang, setisZipang] = useState<boolean>(true);
  const [theme, setTheme] = useState<string>("rgb(217, 43, 60)");
  const fetchNextPageTitle = () => {
    const redirectionType = query.get("redirectionType");
    if (redirectionType === "preview") {
      return "Preview";
    } else if (redirectionType === "productDetail") {
      return "Product Detail";
    } else if (redirectionType === "home") {
      return "Home";
    }
    return "MyAuction Website";
  };
  const fetchInvited = async (auctionId: any): Promise<boolean> => {
    try {
      const response = await api.get(
        `${invitedUserBranchio}?auctionId=${auctionId}`
      );
      console.log("Full API response:", response.data);
      return response.data.isInvited === "true";
    } catch (error) {
      console.error("Error fetching invited users:", error);
      return false;
    }
  };
  useEffect(() => {
    const subdomain = query.get("subdomain");
    if (subdomain === "zipang") {
      setisZipang(true);
      setTheme("rgb(217, 43, 60)");
      localStorage.setItem("isZipangDomain", "true");
      localStorage.setItem("isGlowstarDomain", "false");
    } else {
      setisZipang(false);
      setTheme("#014a99");
    }
    updateBranchLink();
  }, []);

  const updateBranchLink = async () => {
    try {
      let additionalParams = "";
      const redirectionType = query.get("redirectionType");

      let id = "";
      if (redirectionType === "preview") {
        id = query.get("auctionId") ?? "";
      } else if (redirectionType === "productDetail") {
        id = query.get("productId") ?? "";
      } else if (redirectionType === "home") {
        id = "";
      }
      const res = await publicApi.get(
        getLinkBranch +
          `?id=${id}&type=${redirectionType}&subdomain=${isZipang && "zipang"}`
      );
      setBranchLink(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleAppRedirect = () => {
  //   if (branchLink !== undefined) {
  //     window.location.href = branchLink;
  //   }
  // };
  const handleAppRedirect = () => {
    if (!branchLink) return;

    // Replace current URL with origin immediately
    history.push("/");

    // Delay the app redirect very slightly so history change is saved
    setTimeout(() => {
      window.location.href = branchLink;
    }, 100); // 100ms is enough
  };

  const linkRedirectionLogin = async () => {
    const redirectionType = query.get("redirectionType");
    const auctionId = query.get("auctionId");
    const productId = query.get("productId");
    const auctionName = query.get("auctionName");
    const auctionStartDate = query.get("auctionStartDate");
    const category = query.get("category");
    // Auction state response
    const {
      state: auctionStateVal,
      isPreviewStarted: isAuctionPreviewStarted,
      endDate,
    } = await AuctionState(auctionId);
    const { state, auctionEndTime } = await ProductState(productId);
    if (auctionEndTime === undefined) {
      history.push({
        pathname: "/home",
        state: {
          showPopup: true,
          message: "Product has been removed by the organizer",
        },
      });
      return;
    }
    let isAvailable = true;
    if (auctionEndTime !== "" && auctionEndTime != undefined) {
      const today = new Date();
      const auctionendDate = new Date(auctionEndTime.replace(" ", "T"));
      // Add 10 days to auction end date
      const cutoffDate = new Date(
        auctionendDate.getTime() + 10 * 24 * 60 * 60 * 1000
      );
      // Check availability
      isAvailable = today <= cutoffDate;
    }
    // Product state response
    const { state: productStateVal } = await ProductState(productId);

    if (redirectionType === "preview") {
      const isInvited = await fetchInvited(auctionId);
      // to check auction is live or not
      const categoryType =
        category === "Jewellery" ? "jewelleyProducts" : "products";
      if (isInvited === true && isAuctionPreviewStarted === true) {
        history.push(
          `../../../preview/${categoryType}/${auctionId}/${auctionName}/${auctionStartDate}`
        );
      } else {
        const pastAuctionProducts = await getPastProducts();

        if (pastAuctionProducts?.results?.length > 0) {
          history.push({
            pathname: "/publicpreview/pastproducts",
            search: "?pastProducts=true",
          });
          return;
        } else {
          history.push({
            pathname: "/home",
            state: { showPopup: true, message: "No Ongoing Auctions found." },
          });
        }
      }
    } else if (redirectionType === "productDetail") {
      localStorage.setItem("isZipangDomain", "true");
      localStorage.setItem("isGlowstarDomain", "false");
      if (auctionStateVal === "Cancelled") {
        history.push({
          pathname: "/home",
          state: {
            showPopup: true,
            message: "Auction has been cancelled by the organizer",
          },
        });
        return;
      } else if (
        productStateVal === "Pending" ||
        productStateVal === "Auction_Cancelled" ||
        productStateVal === "Cancel"
      ) {
        history.push({
          pathname: "/home",
          state: {
            showPopup: true,
            message: "Product has been removed by the organizer",
          },
        });
        return;
      }
      if (!oAuth()) {
        if (isAuctionPreviewStarted === false) {
          history.push({
            pathname: "/home",
            state: { showPopup: true, message: "Preview not started" },
          });
          return;
        } else {
          if (isAvailable) {
            const categoryType = category === "Jewellery" ? "/jewellery" : "";
            history.push(
              `../../../product${categoryType}/${productId}/${auctionStartDate}/detail`
            );
          } else {
            history.push({
              pathname: "/home",
              state: {
                showPopup: true,
                message: "Product has been removed by the organizer",
              },
            });
          }
        }
      } else {
        if (isAuctionPreviewStarted === false) {
          history.push({
            pathname: "/home",
            state: { showPopup: true, message: "Preview not started" },
          });
          return;
        } else {
          const categoryType =
            category === "Jewellery" ? "/jewelleyProducts" : "";
          history.push(
            `../../../preview${categoryType}/details/${auctionId}/${productId}/${auctionStartDate}`
          );
        }
      }
    }
  };

  const handleWebRedirect = async () => {
    try {
      const redirectionType = query.get("redirectionType");
      if (!redirectionType) throw "";

      const auctionId = query.get("auctionId");
      const productId = query.get("productId"); // may be null for preview
      const auctionName = query.get("auctionName");
      const auctionStartDate = query.get("auctionStartDate");
      const category = query.get("category");

      // --- Auction state ---
      const {
        state: auctionStateVal,
        isPreviewStarted,
        endDate,
      } = await AuctionState(auctionId);

      let auctionEndTime: string | undefined;
      let productStateVal: string | undefined;
      let isAdvertised: boolean | undefined;
      // --- Only call ProductState when productDetail ---
      if (redirectionType === "productDetail" && productId) {
        const productResp = await ProductState(productId);
        auctionEndTime = productResp.auctionEndTime;
        productStateVal = productResp.state;
        isAdvertised = productResp.isAdvertised;

        if (auctionEndTime === undefined) {
          history.push({
            pathname: "/home",
            state: {
              showPopup: true,
              message: "Product has been removed by the organizer",
            },
          });
          return;
        }
      }

      // --- Availability check only for productDetail ---
      let isAvailable = true;
      // if (redirectionType === "productDetail" && auctionEndTime) {
      //   const today = new Date();
      //   const auctionEndDate = new Date(auctionEndTime.replace(" ", "T"));
      //   const cutoffDate = new Date(
      //     auctionEndDate.getTime() + 10 * 24 * 60 * 60 * 1000
      //   );
      //   isAvailable = today <= cutoffDate;
      // }
      if (redirectionType === "productDetail" && auctionEndTime) {
        // Advertised products are always available
        if (!isAdvertised) {
          const today = new Date();
          const auctionEndDate = new Date(auctionEndTime.replace(" ", "T"));
          const cutoffDate = new Date(
            auctionEndDate.getTime() + 10 * 24 * 60 * 60 * 1000
          );

          isAvailable = today <= cutoffDate;
        } else {
          isAvailable = true;
        }
      }

      // --- Handle Preview Redirect ---
      if (redirectionType === "preview") {
        if (auctionStateVal === "Ended" || auctionStateVal === "Cancelled") {
          const pastAuctionProducts = await getPastProducts();

          if (pastAuctionProducts?.results?.length > 0) {
            history.push({
              pathname: "/publicpreview/pastproducts",
              search: "?pastProducts=true",
            });
            return;
          } else {
            history.push({
              pathname: "/home",
              state: { showPopup: true, message: "Auction has ended." },
            });
            return;
          }
        }

        const categoryType =
          category === "Jewellery" ? "jewelleyProducts" : "products";
        if (isPreviewStarted) {
          history.push(
            `../../../preview/${categoryType}/${auctionId}/${auctionName}/${auctionStartDate}`
          );
        } else {
          const pastAuctionProducts = await getPastProducts();

          if (pastAuctionProducts?.results?.length > 0) {
            history.push({
              pathname: "/publicpreview/pastproducts",
              search: "?pastProducts=true",
            });
            return;
          } else {
            history.push({
              pathname: "/home",
              state: { showPopup: true, message: "No Ongoing Auctions found." },
            });
          }
        }
      }

      // --- Handle Product Detail Redirect ---
      if (redirectionType === "productDetail") {
        if (auctionStateVal === "Cancelled") {
          history.push({
            pathname: "/home",
            state: {
              showPopup: true,
              message: "Auction has been cancelled by the organizer",
            },
          });
          return;
        }

        if (
          productStateVal === "Pending" ||
          productStateVal === "Auction_Cancelled" ||
          productStateVal === "Cancel"
        ) {
          history.push({
            pathname: "/home",
            state: {
              showPopup: true,
              message: "Product has been removed by the organizer",
            },
          });
          return;
        }

        if (!oAuth()) {
          if (!isPreviewStarted) {
            history.push({
              pathname: "/home",
              state: { showPopup: true, message: "Preview not started" },
            });
            return;
          }

          if (isAvailable) {
            const categoryType = category === "Jewellery" ? "/jewellery" : "";
            history.push(
              `../../../product${categoryType}/${productId}/${auctionStartDate}/detail`
            );

            localStorage.setItem(
              "afterloginlink",
              `../../../preview${categoryType}/details/${auctionId}/${productId}/${auctionStartDate}`
            );
            localStorage.setItem("branchiolink", fullUrl);
          } else {
            history.push({
              pathname: "/home",
              state: {
                showPopup: true,
                message: "Product has been removed by the organizer",
              },
            });
          }
          return;
        } else {
          if (!isPreviewStarted) {
            history.push({
              pathname: "/home",
              state: { showPopup: true, message: "Preview not started" },
            });
            return;
          }

          const categoryType =
            category === "Jewellery" ? "/jewelleyProducts" : "";
          history.push(
            `../../../preview${categoryType}/details/${auctionId}/${productId}/${auctionStartDate}`
          );
          return;
        }
      }

      // --- Handle Home Redirect ---
      if (redirectionType === "home") {
        history.push(`/home`);
        return;
      }

      // // --- Default case (login) ---
      // history.push(`/`);
      // localStorage.setItem("openlogin", "true");
    } catch (error) {
      console.error("Redirect error:", error);
      history.push(`/`);
      localStorage.setItem("openlogin", "true");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundImage: {
          xs: `url(/images/branchBackground/backgroundMobile${
            isZipang ? "Zipang" : ""
          }.png)`,
          sm: `url(/images/branchBackground/backgroundMobile${
            isZipang ? "Zipang" : ""
          }.png)`,
          md: `url(/images/branchBackground/backgroundMobile${
            isZipang ? "Zipang" : ""
          }.png)`,
          lg: `url(/images/branchBackground/backgroundTab${
            isZipang ? "Zipang" : ""
          }.png)`,
          xl: `url(/images/branchBackground/backgroundWeb${
            isZipang ? "Zipang" : ""
          }.png)`,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          backgroundColor: "rgb(0,0,0,0.6)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "5%",
            width: {
              xs: "90%", // 0px and up
              sm: "90%", // 600px and up
              md: "60%", // 900px and up
              lg: "40%", // 1200px and up
            },
            gap: {
              xs: 4,
              sm: 4,
              md: 4,
              lg: 2,
            },
            backgroundColor: "white",
            borderRadius: 5,
            justifyContent: "space-between",
            alignItems: "center",
            borderWidth: 1,
            borderColor: theme,
            borderStyle: "solid",
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: {
                sm: 20,
                md: 35,
              },
            }}
          >
            Redirecting To {fetchNextPageTitle()}
          </Typography>
          <Box>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: {
                  sm: 15,
                  md: 25,
                },
              }}
            >
              Thanks for connectiong with us!
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: {
                  sm: 15,
                  md: 25,
                },
              }}
            >
              Elevate your bidding experience - download our app today for
              seamless experience
            </Typography>
          </Box>
          <Box style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <Box
              onClick={handleWebRedirect}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                backgroundColor: theme,
                borderRadius: 20,
                padding: "5px 15px 5px 15px",
                cursor: "pointer", // makes it look clickable
                userSelect: "none",
              }}
            >
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                height="40px"
                viewBox="0 -960 960 960"
                width="40px"
                fill="#e3e3e3"
              >
                <path d="M838-65 720-183v89h-80v-226h226v80h-90l118 118-56 57ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 20-2 40t-6 40h-82q5-20 7.5-40t2.5-40q0-20-2.5-40t-7.5-40H654q3 20 4.5 40t1.5 40q0 20-1.5 40t-4.5 40h-80q3-20 4.5-40t1.5-40q0-20-1.5-40t-4.5-40H386q-3 20-4.5 40t-1.5 40q0 20 1.5 40t4.5 40h134v80H404q12 43 31 82.5t45 75.5q20 0 40-2.5t40-4.5v82q-20 2-40 4.5T480-80ZM170-400h136q-3-20-4.5-40t-1.5-40q0-20 1.5-40t4.5-40H170q-5 20-7.5 40t-2.5 40q0 20 2.5 40t7.5 40Zm34-240h118q9-37 22.5-72.5T376-782q-55 18-99 54.5T204-640Zm172 462q-18-34-31.5-69.5T322-320H204q29 51 73 87.5t99 54.5Zm28-462h152q-12-43-31-82.5T480-798q-26 36-45 75.5T404-640Zm234 0h118q-29-51-73-87.5T584-782q18 34 31.5 69.5T638-640Z" />
              </svg> */}
              <StyledIcon src="/images/svgimages/file 1.svg" />
              <Typography
                sx={{
                  color: "white",
                  fontSize: {
                    sm: 15,
                    md: 25,
                  },
                }}
              >
                Continue with Browser
              </Typography>
            </Box>
            {isMobileRedirectVisible && branchLink && isZipang && (
              <Box
                onClick={handleAppRedirect}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  gap: 10,
                  backgroundColor: "white",
                  borderRadius: 20,
                  padding: "5px 15px 5px 15px",
                  cursor: "pointer", // makes it look clickable
                  userSelect: "none",
                  borderWidth: 1,
                  borderColor: theme,
                  borderStyle: "solid",
                }}
              >
                <img
                  src="/images/zipangLogo.png"
                  alt="Chrome Icon"
                  width={30}
                  height={30}
                />

                <Typography
                  sx={{
                    color: theme,
                    fontSize: {
                      sm: 15,
                      md: 25,
                    },
                  }}
                >
                  Continue with App
                </Typography>
              </Box>
            )}
          </Box>
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                color: "black",
                fontSize: {
                  sm: 15,
                  md: 25,
                },
              }}
            >
              Don't have the App
            </Typography>
            <Box onClick={handleAppRedirect}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: theme,
                  cursor: "pointer", // makes it look clickable
                  userSelect: "none",
                  fontSize: {
                    sm: 15,
                    md: 25,
                  },
                }}
              >
                Download it now
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default BranchRedirect;
